export default __webpack_public_path__ + "static/media/logo.245a6755.png";